export enum InputType {
    select = 'select',
    input = 'input',
    textarea = 'textarea',
    email = 'email',
    text = 'text',
    number = 'number',
    password = 'password',
    phone = 'phone'
}
